__turbopack_context__.v({
  "labelWrapper": "GuaranteeTag-module___GkBCG__labelWrapper",
});
